import Trainplanet from "./../../util/trainplanet.api";

const vuex = {};

vuex.state = {
  statistics: {
    // Top-level summary/period fields are totals converted to SEK; per-currency values are under byCurrency
    summary: {
      orderCount: 0,
      journeyCount: 0,
      railPassCount: 0,
      taxiCount: 0,
      giftCardCount: 0,
      articleCount: 0,
      byCurrency: [],
    },
    monthly: [],
    daily: [],
  },
};
vuex.getters = {
  statistics: (state) => state.statistics,
};
vuex.mutations = {
  setStatistics(state, statistics) {
    state.statistics = statistics;
  },
};
vuex.actions = {
  async getStatistics({ commit }, params) {
    const res = await Trainplanet.getStatistics(params);
    commit("setStatistics", res);
  },
};

export default {
  namespaced: true,
  state: vuex.state,
  getters: vuex.getters,
  mutations: vuex.mutations,
  actions: vuex.actions,
};
